{
	"error": "Erreur !",
	"success": "Succès !",
	"warning": "Attention !"
}
